import { deserialize as fcDeserialize, deserializeStream as fcDeserializeStream, deserializeFiltered as fcDeserializeFiltered, serialize as fcSerialize, } from './geojson/featurecollection.js';
export function serialize(geojson) {
    const bytes = fcSerialize(geojson);
    return bytes;
}
export function deserialize(input, rect, headerMetaFn) {
    if (input instanceof Uint8Array)
        return fcDeserialize(input, headerMetaFn);
    else if (input instanceof ReadableStream)
        return fcDeserializeStream(input, headerMetaFn);
    else
        return fcDeserializeFiltered(input, rect, headerMetaFn);
}
//# sourceMappingURL=geojson.js.map